import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'grid',
    placeItems: 'center',
    border: '1px solid #8F8F8F',
    borderRadius: '50%',
    boxSizing: 'border-box',
    width: '16px',
    height: '16px',
    cursor: 'pointer'
  },

  button: {
    borderRadius: '50%',
    width: '10px',
    height: '10px',
    background: ({ checked }) =>
      checked ? theme.palette.primary.main : 'transparent',
    transition: 'all 250ms'
  }
}))

export default useStyles
